var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from 'react';
import { useSprings, animated } from '@react-spring/web';
import { useDrag } from 'react-use-gesture';
import clamp from 'lodash.clamp';
import swap from 'lodash-move';
import styled from 'styled-components';
const height = 110;
const StyledDnd = styled.div `
  & {
    position: relative;
    width: 200px;
  }

  & > div {
    width: 200px;
    position: absolute;
    transform-origin: 50% 50% 0px;
    border-radius: 5px;
    color: white;
    line-height: 40px;
    padding-left: 32px;
    font-size: 14.5px;
    background: lightblue;
    text-transform: uppercase;
    letter-spacing: 2px;
    touch-action: none;
  }
`;
const fn = (order, itemHeight = height, active = false, originalIndex = 0, curIndex = 0, y = 0) => (index) => active && index === originalIndex
    ? {
        y: curIndex * itemHeight + y,
        zIndex: 1,
        shadow: 15,
        immediate: (key) => key === 'y' || key === 'zIndex',
    }
    : {
        y: order.indexOf(index) * itemHeight,
        zIndex: 0,
        shadow: 1,
        immediate: false,
    };
export function DraggableList(_a) {
    var { dataSource, className, itemHeight } = _a, props = __rest(_a, ["dataSource", "className", "itemHeight"]);
    const order = useRef(dataSource.map((_, index) => index)); // Store indicies as a local ref, this represents the item order
    const [springs, api] = useSprings(dataSource.length, fn(order.current, itemHeight)); // Create springs, each corresponds to an item, controlling its transform, scale, etc.
    const bind = useDrag(({ args: [originalIndex], active, movement: [, y] }) => {
        const curIndex = order.current.indexOf(originalIndex);
        const curRow = clamp(Math.round((curIndex * 100 + y) / 100), 0, dataSource.length - 1);
        console.log(curRow);
        const newOrder = swap(order.current, curIndex, curRow);
        api.start(fn(newOrder, itemHeight, active, originalIndex, curIndex, y)); // Feed springs new style data, they'll animate the view without causing a single render
        if (!active)
            order.current = newOrder;
    });
    return (React.createElement(StyledDnd, { className: className }, springs.map(({ zIndex, shadow, y }, i) => {
        var _a;
        return (React.createElement(animated.div, Object.assign({}, bind(i), { key: i, "data-index": dataSource[i], style: {
                zIndex,
                boxShadow: shadow.to((s) => `rgba(0, 0, 0, 0.15) 0px ${s}px ${2 * s}px 0px`),
                y,
            }, children: (_a = props.renderItem) === null || _a === void 0 ? void 0 : _a.call(props, dataSource[i]) })));
    })));
}
